import { useState } from 'react'

/**
 * Replacement for react-storefront/hooks/useLazyState. The original had a
 * complex client-navigation refetch path tied to the createLazyProps /
 * useLazyState pair. Now that pages get data from getServerSideProps the
 * props ARE the final state on first render; no client refetch is needed.
 *
 * Returns [state, setState] where state is the seeded props (with
 * `loading: false`). Existing consumers that read `state.pageData`,
 * `state.appData`, or `state.loading` keep working as-is.
 */
export default function useLazyState(lazyProps = {}) {
  const [state, setState] = useState(() => ({
    loading: false,
    ...lazyProps,
  }))
  return [state, setState]
}
